/**
 * @fileoverview Componente principal de la aplicación que maneja la configuración inicial
 * y la estructura base de la interfaz.
 */
import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { ConfirmationService, MessageService } from 'primeng/api';
import { PrimeNG } from 'primeng/config';
import { ConfirmDialog } from 'primeng/confirmdialog';
import { Toast } from 'primeng/toast';

import { ThemeService } from '../protected-area/services/theme.service';
import { setupPrimeNGConfig } from './primeng-config';

/**
 * @class AppComponent
 * @description Componente raíz de la aplicación que inicializa las configuraciones básicas
 * y gestiona el estado global de la aplicación.
 */
@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, Toast, ConfirmDialog],
  template: `<p-toast
      [position]="'top-right'"
      [preventOpenDuplicates]="true"
    ></p-toast>
    <p-confirmdialog />
    <router-outlet />`,
  providers: [MessageService, ConfirmationService],
})
export class AppComponent implements OnInit {
  /**
   * @constructor
   * @param {PrimeNG} primengConfig - Servicio de configuración de PrimeNG
   * @param {ThemeService} themeService - Servicio para gestionar el tema de la aplicación
   */
  constructor(
    private primengConfig: PrimeNG,
    private themeService: ThemeService,
    private msalService: MsalService,
  ) {
    // Initialize MSAL at app startup
    this.msalService.initialize().subscribe();
  }

  ngOnInit() {
    setupPrimeNGConfig(this.primengConfig);
    this.themeService.initializeTheme();
  }
}
